import React, { useEffect, useContext, useState, useReducer } from 'react';
import axios from 'axios';
import {apiRoutes} from '../../../AppSettings';
import { AuthContext } from '../../../contexts/AuthContext';
import ReactStars from "react-rating-stars-component";
import Util from '../../../Util';

const LOAD_REVIEWS = "LOAD_REVIEWS"

const initialState = {
    reviews: []
} 

const reducer = (state, action)=>{
    switch(action.type)
    {
        case LOAD_REVIEWS:
            return { ...state, reviews: action.reviews };
    }
}

const Reviews = props => {
    let doctor = props.doctor;
    const { userState } = useContext(AuthContext);

    const [state, dispature] = useReducer(reducer, initialState);

    const initialValueReview = {
		doctorId: doctor.doctorId,
		rating: 0,
		title: '',
        review: '',
        CreatedBy: userState.loggedInUser.firstName + ' ' + userState.loggedInUser.lastName,
        userType: userState.userType
    };

    const initialValueReply = {
        reviewId: 0,
        review: '',
        CreatedBy: userState.loggedInUser.firstName + ' ' + userState.loggedInUser.lastName,
        userType: userState.userType,
        recommand: false
    };
    

	const [review, setReview] = useState(initialValueReview);
    const [reply, setReply] = useState(initialValueReply);

    const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Authorization': 'bearer '+userState.token
		}
    };
    
    const loadReviews = (loadall) => {
        axios.get(apiRoutes.loadReviews + doctor.doctorId, options)
		.then((response) => {
			if(response.status === 200)
			{
                const data = response.data;
                if(loadall)
                {
                    dispature({type: LOAD_REVIEWS, reviews: response.data});
                }
                else
                {
                    dispature({type: LOAD_REVIEWS, reviews: response.data.slice(0,10)});
                }
			}
		}, (error) => {
			console.log(error);
		});
    }

    useEffect(() => {
        loadReviews();
    }, []);

	const reviewSubmit = e => {
		e.preventDefault();
		axios.post(apiRoutes.createReview, JSON.stringify(review), options)
		.then((response) => {
		 	if(response.status === 200)
		  	{
                loadReviews();
			}
	    }, (error) => {
		    console.log(error);
	    });
    }

    const replySubmit = (e) => {
        e.preventDefault();

        axios.post(apiRoutes.submitReply, JSON.stringify(reply), options)
		.then((response) => {
		 	if(response.status === 200)
		  	{
                loadReviews();;
			}
	    }, (error) => {
		    console.log(error);
	    });
    }

    const recommand = (e, reviewId, value) => {
        e.preventDefault();
        const obj = {
            reviewId: reviewId,
            review: '',
            CreatedBy: userState.loggedInUser.firstName + ' ' + userState.loggedInUser.lastName,
            userType: userState.userType,
            recommand: value
        };

        axios.post(apiRoutes.submitRecommand, JSON.stringify(obj), options)
		.then((response) => {
		 	if(response.status === 200)
		  	{
                loadReviews();;
			}
	    }, (error) => {
		    console.log(error);
	    });
    }

    const toggleReply = (e, toggelFor, id, show) => {
        e.preventDefault();
        switch(toggelFor)
        {
            case "reply":
                state.reviews.forEach(element => {
                    element.reviewReply.forEach(item => {
                        if(item.reviewReplyId == id)
                            item.showReplyBox = show;
                    });    
                });
                break;
            case "review":
                state.reviews.forEach(element => {
                    if(element.reviewId == id)
                        element.showReplyBox = show;
                });
                break;
        }
        dispature({type: LOAD_REVIEWS, reviews: state.reviews});
    }

    const loadall = () => {
        loadReviews(true);
    } 

    return ( 
        <div>
            <div className="widget review-listing">
                <ul className="comments-list">
                    {
                        state.reviews.map(review => (
                            <li>
                                <div className="comment">
                                    <img className="avatar avatar-sm rounded-circle" alt="User Image" src="assets/img/patients/patient.jpg" />
                                    <div className="comment-body">
                                        <div className="meta-data">
                                            <span className="comment-author">{review.createdBy }</span>
                                            <span className="comment-date">Reviewed { Util.getDateDifffromToDay(review.createdDate) } </span>
                                            <div className="review-count rating">
                                                <ReactStars value={review.rating} edit={false} size={20} />
                                            </div>
                                        </div>
                                        {
                                            review.recommand &&  <p className="recommended"><i className="far fa-thumbs-up"></i> I recommend the doctor</p>
                                        }
                                        <p className="comment-content">
                                            {review.review}
                                        </p>

                                        <div className="comment-reply">
                                            <a className="comment-btn cursor-pointer" onClick={e => toggleReply(e, 'review', review.reviewId, true)} >
                                                <i className="fas fa-reply"></i> Reply
                                            </a>
                                            <p className="recommend-btn">
                                                <span>Recommend?</span>
                                                <a onClick={(e) => recommand(e, review.reviewId, true)} className="like-btn">
                                                    <i className="far fa-thumbs-up"></i> Yes
                                                </a>
                                                <a onClick={(e) => recommand(e, review.reviewId, false)} className="dislike-btn">
                                                    <i className="far fa-thumbs-down"></i> No
                                                </a>
                                             </p>
                                        </div>
                                        {
                                            review.showReplyBox && 
                                            <div className="write-review">
                                                <form onSubmit={(e) => replySubmit(e)}>
                                                    <div className="form-group">
                                                        <textarea id="review_desc" maxLength="100" className="form-control" 
                                                            placeholder="write a reply"
                                                            onChange={e => setReply({...reply, reviewId: review.reviewId, review: e.target.value})}
                                                            required ></textarea>
                                                        <div className="d-flex justify-content-between mt-3"><small className="text-muted"><span id="chars">100</span> characters remaining</small></div>
                                                    </div>
                                                    <div className="submit-section">
                                                        <button type="submit" className="btn btn-primary submit-btn" >Reply</button>
                                                        <button className="btn btn-primary submit-btn" onClick={e => toggleReply(e, 'review', review.reviewId, false)}>Cancel</button>
                                                    </div>
                                                </form>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <ul className="comments-reply">
                                {
                                    review.reviewReply != undefined &&
                                    review.reviewReply.map(reply => (
                                        <li>
                                            <div className="comment">
                                                <img className="avatar avatar-sm rounded-circle" alt="User Image" src="assets/img/patients/patient1.jpg" /> 
                                                <div className="comment-body">
                                                    <div className="meta-data">
                                                        <span className="comment-author">{reply.createdBy}</span>
                                                        <span className="comment-date">Replied {Util.getDateDifffromToDay(reply.createdDate)}</span>
                                                        <div className="review-count rating">
                                                          
                                                        </div>
                                                    </div>
                                                    <p className="comment-content">
                                                        {reply.review}
                                                    </p>
                                                    <div className="comment-reply">
                                                        <a className="comment-btn" onClick={e => toggleReply(e, 'reply', reply.reviewReplyId, true)}>
                                                            <i className="fas fa-reply"></i> Reply
                                                        </a>
                                                    </div>
                                                    {
                                                        reply.showReplyBox && 
                                                        <div className="write-review">
                                                            <form onSubmit={(e) => replySubmit(e)}>
                                                                <div className="form-group">
                                                                    <textarea id="review_desc" maxLength="100" className="form-control" 
                                                                        placeholder="write a reply"
                                                                        onChange={e => setReply({...reply, reviewId: reply.reviewId, review: e.target.value})}
                                                                        ></textarea>
                                                                    <div className="d-flex justify-content-between mt-3"><small className="text-muted"><span id="chars">100</span> characters remaining</small></div>
                                                                </div>
                                                                <div className="submit-section">
                                                                    <button type="submit" className="btn btn-primary submit-btn" >Reply</button>
                                                                    <button className="btn btn-primary submit-btn" onClick={e => toggleReply(e, 'reply', reply.reviewReplyId, false)}>Cancel</button>
                                                                </div>
                                                            </form>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </li>
                               
                                    ))
                                   
                                }
                                 </ul>
                            </li>
                        ))
                    }
                </ul>
                <div className="all-feedback text-center">
                    <a href="#" className="btn btn-primary btn-sm" onClick={loadall}>
                        Show all feedback
                    </a>
                </div>
            </div>
            <div className="write-review">
                <h4>Write a review for <strong>Dr. {doctor.firstName} {doctor.lastName}</strong></h4>
                <form onSubmit={(e) => reviewSubmit(e)}>
                    <div className="form-group">
                        <label>Review</label>
                        <ReactStars value={0} size={20} onChange={value => setReview({...review, rating: value})} />
                    </div>
                    <div className="form-group">
                        <label>Title of your review</label>
                        <input className="form-control" type="text" 
                            placeholder="If you could say it in one sentence, what would you say?" 
                            onChange={e => setReview({...review, title: e.target.value})}/>
                    </div>
                    <div className="form-group">
                        <label>Your review</label>
                        <textarea id="review_desc" maxLength="100" className="form-control" 
                            onChange={e => setReview({...review, review: e.target.value})}
                            ></textarea>
                        
                        <div className="d-flex justify-content-between mt-3"><small className="text-muted"><span id="chars">100</span> characters remaining</small></div>
                    </div>
                    <div className="submit-section">
                        <button type="submit" className="btn btn-primary submit-btn">Add Review</button>
                    </div>
                </form>
            </div>
        </div>
     );
}
 
export default Reviews;